import { unitsInLinesText } from '../../lib/unitLines';

/**
 * SIL-1648: "N units in M lines" beside the portfolio asset total. Renders
 * nothing unless the org holds at least one stock line (units !== lines).
 */
export function PortfolioUnits({
  totalAssetCount,
  totalLineCount,
}: {
  totalAssetCount: number;
  totalLineCount: number;
}) {
  const text = unitsInLinesText(totalAssetCount, totalLineCount);
  if (!text) return null;
  return (
    <p className="text-sm text-muted-foreground" data-testid="portfolio-units">
      {text}
    </p>
  );
}
